module.exports = __webpack_public_path__ + "static/img_order-c8092f0eda27fa46afb2417bc28c1719.jpg";